// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-p_fZ","advertDetailParameterList__header":"c-p_ga","advertDetailParameterList__list":"c-p_gb"};